import styled from 'styled-components'

export const TabWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;

  button {
    min-width: 100px;
    font-size: 14px;
    background: #eef7fc;
    color: #278cb5;
    border-radius: 2px;
    cursor: pointer;
    border: solid 1px #278cb5;
    padding: 2px;
    border-radius: 2px;
  }
`
